import React, { useState, useEffect } from 'react';
import { TrendingUp, Users, Mail, Check, BookOpen, Sparkles, Crown } from 'lucide-react';

const TransformationFunnel = ({ timeRange }) => {
  const API_BASE_URL = process.env.REACT_APP_BACKEND_URL;
  const [funnelData, setFunnelData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchFunnelData();
  }, [timeRange]);

  const fetchFunnelData = async () => {
    try {
      const token = localStorage.getItem('admin_token');
      const response = await fetch(
        `${API_BASE_URL}/api/admin/dashboard/funnel?time_range=${timeRange}`,
        { headers: { Authorization: `Bearer ${token}` } }
      );
      if (response.ok) {
        const data = await response.json();
        setFunnelData(data);
      }
    } catch (error) {
      console.error('Error fetching funnel data:', error);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return <div className="animate-pulse bg-white/50 rounded-2xl h-96"></div>;
  }

  if (!funnelData) return null;

  const stepIcons = [Users, Mail, Check, BookOpen, Sparkles, Crown];

  return (
    <div className="relative overflow-hidden rounded-2xl p-8 backdrop-blur-xl"
         style={{
           background: 'linear-gradient(135deg, rgba(255, 255, 255, 0.95) 0%, rgba(255, 255, 255, 0.85) 100%)',
           border: '1px solid rgba(255, 182, 193, 0.3)',
         }}>
      <h3 className="text-2xl font-bold bg-gradient-to-r from-rose-500 to-pink-600 bg-clip-text text-transparent mb-6">
        🎯 Transformation Funnel
      </h3>

      <div className="space-y-4">
        {funnelData.steps.map((step, index) => {
          const Icon = stepIcons[index];
          const width = (step.count / funnelData.steps[0].count) * 100;
          const isLast = index === funnelData.steps.length - 1;

          return (
            <div key={step.name}>
              <div className="flex items-center justify-between mb-2">
                <div className="flex items-center gap-3">
                  <div className="w-10 h-10 rounded-xl bg-gradient-to-br from-rose-400 to-pink-500 flex items-center justify-center">
                    <Icon className="w-5 h-5 text-white" />
                  </div>
                  <span className="font-semibold text-gray-900">{step.name}</span>
                </div>
                <div className="text-right">
                  <div className="font-bold text-lg text-gray-900">{step.count}</div>
                  <div className="text-sm text-gray-600">{step.conversion}%</div>
                </div>
              </div>

              <div className="relative h-12 bg-gray-100 rounded-xl overflow-hidden mb-2">
                <div
                  className="absolute inset-y-0 left-0 bg-gradient-to-r from-rose-400 to-pink-500 transition-all duration-1000 flex items-center justify-end pr-4"
                  style={{ width: `${width}%` }}
                >
                  <span className="text-white font-semibold text-sm">
                    {step.conversion}%
                  </span>
                </div>
              </div>

              {!isLast && (
                <div className="flex items-center justify-center py-2">
                  <div className="text-gray-400">
                    <TrendingUp className="w-5 h-5" />
                  </div>
                </div>
              )}
            </div>
          );
        })}
      </div>

      <div className="mt-6 p-4 bg-gradient-to-r from-rose-50 to-pink-50 rounded-xl border border-rose-200">
        <p className="text-center text-gray-700">
          <span className="font-bold text-rose-600">Overall Conversion:</span>{' '}
          {funnelData.overall_conversion}% of signups become paid customers
        </p>
      </div>
    </div>
  );
};

export default TransformationFunnel;